import { useLang } from "@/context/LanguageContext";
import Reveal from "./Reveal";
import { ShieldCheck, Clock, MapPin } from "lucide-react";

export default function Trust() {
  const { t } = useLang();
  const items = [
    { icon: ShieldCheck, t: t("trust.f1_t"), d: t("trust.f1_d") },
    { icon: Clock, t: t("trust.f2_t"), d: t("trust.f2_d") },
    { icon: MapPin, t: t("trust.f3_t"), d: t("trust.f3_d") },
  ];
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl text-ksy-navy tracking-tight">{t("trust.title")}</h2>
          <p className="mt-3 text-lg text-slate-500">{t("trust.subtitle")}</p>
        </Reveal>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <Reveal key={i} delay={i * 0.08} testid={`trust-card-${i}`}>
              <div className="h-full rounded-2xl border border-slate-200 bg-slate-50/60 p-8 hover:shadow-lg hover:border-blue-200 hover:-translate-y-1 transition-all duration-300">
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-ksy-navy text-white mb-5">
                  <it.icon className="w-6 h-6" />
                </span>
                <h3 className="font-display font-bold text-xl text-ksy-navy">{it.t}</h3>
                <p className="mt-2 text-slate-500 leading-relaxed">{it.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
